// @ts-nocheck
import { Call } from "@guava-ai/guava-sdk/src/webrtc/index.ts";

(function () {
  var scriptEl = document.currentScript;

  // ── Inject font ──
  var link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = "https://fonts.googleapis.com/css2?family=Barlow:wght@600&display=swap";
  document.head.appendChild(link);

  // ── Inject CSS ──
  var css = `
    [data-guava-widget] {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      padding: 16px 16px 16px;
      min-width: 139px;
      border: 1px solid rgba(78, 203, 141, 0.2);
      border-radius: 20px 20px 0 20px;
      background: rgba(22, 27, 34, 0.55);
      box-shadow:
        0 8px 32px rgba(0,0,0,0.4),
        inset 0 1px 0 rgba(255,255,255,0.06);
      backdrop-filter: blur(12px);
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
      user-select: none;
      box-sizing: border-box;
      cursor: pointer;
      position: relative;
      transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
    [data-guava-widget][data-guava-state="connecting"] {
      pointer-events: none;
      cursor: default;
    }
    [data-guava-widget][data-guava-state="error"] {
      border-color: rgba(226, 75, 74, 0.25);
    }
    [data-guava-widget] *, [data-guava-widget] *::before, [data-guava-widget] *::after {
      box-sizing: border-box;
    }

    /* ── Hover ── */
    [data-guava-widget][data-guava-state="idle"]:hover,
    [data-guava-widget][data-guava-state="error"]:hover,
    [data-guava-widget][data-guava-state="active"]:hover {
      transform: translateY(-2px);
      box-shadow:
        0 12px 40px rgba(0,0,0,0.5),
        inset 0 1px 0 rgba(255,255,255,0.08);
      transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
    [data-guava-widget][data-guava-state="idle"]:hover .gw-orb,
    [data-guava-widget][data-guava-state="error"]:hover .gw-orb {
      box-shadow: 0 0 18px rgba(78, 203, 141, 0.5);
      transition: box-shadow 0.2s ease;
    }
    [data-guava-widget][data-guava-state="error"]:hover .gw-orb {
      box-shadow: 0 0 18px rgba(226, 75, 74, 0.5);
    }
    [data-guava-widget][data-guava-state="idle"]:hover .gw-orb-inner {
      filter: brightness(1.15);
    }

    /* ── Orb ── */
    [data-guava-widget] .gw-orb {
      width: 72px;
      height: 72px;
      border-radius: 50%;
      position: relative;
      cursor: pointer;
      flex-shrink: 0;
      box-shadow: 0 0 10px rgba(78, 203, 141, 0.35);
      transition: box-shadow 0.2s ease;
    }
    [data-guava-widget][data-guava-state="error"] .gw-orb {
      box-shadow: 0 0 10px rgba(226, 75, 74, 0.35);
    }
    [data-guava-widget] .gw-orb-inner {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background: #1a6b5a;
      overflow: hidden;
      position: relative;
      transition: filter 0.3s;
      -webkit-mask-image: radial-gradient(circle, #fff 100%, transparent 100%);
      mask-image: radial-gradient(circle, #fff 100%, transparent 100%);
    }

    /* Fluid blob layers */
    [data-guava-widget] .gw-blob {
      position: absolute;
      border-radius: 50%;
      mix-blend-mode: screen;
      filter: blur(6px);
      will-change: transform;
    }
    [data-guava-widget] .gw-blob-1 {
      width: 140%; height: 140%; top: -20%; left: -20%;
      background: radial-gradient(circle, #7ecfcf 0%, transparent 60%);
      animation: gw-drift-1 8s ease-in-out infinite;
    }
    [data-guava-widget] .gw-blob-2 {
      width: 120%; height: 120%; top: -10%; left: -10%;
      background: radial-gradient(circle, #4a9e6e 0%, transparent 55%);
      animation: gw-drift-2 10s ease-in-out infinite;
    }
    [data-guava-widget] .gw-blob-3 {
      width: 130%; height: 130%; top: -15%; left: -15%;
      background: radial-gradient(circle, #2a7fa8 0%, transparent 55%);
      animation: gw-drift-3 12s ease-in-out infinite;
    }
    [data-guava-widget] .gw-blob-4 {
      width: 110%; height: 110%; top: -5%; left: -5%;
      background: radial-gradient(circle, #3db87a 0%, transparent 50%);
      animation: gw-drift-4 9s ease-in-out infinite;
    }
    [data-guava-widget] .gw-blob-5 {
      width: 100%; height: 100%; top: 0; left: 0;
      background: radial-gradient(ellipse at 50% 50%, rgba(15,60,40,0.6) 0%, transparent 65%);
      mix-blend-mode: multiply;
      filter: blur(8px);
      animation: gw-drift-5 11s ease-in-out infinite;
    }

    @keyframes gw-drift-1 {
      0%, 100% { transform: translate(0%, 0%) rotate(0deg); }
      25%      { transform: translate(15%, -10%) rotate(90deg); }
      50%      { transform: translate(-10%, 15%) rotate(180deg); }
      75%      { transform: translate(-15%, -5%) rotate(270deg); }
    }
    @keyframes gw-drift-2 {
      0%, 100% { transform: translate(0%, 0%) rotate(0deg); }
      25%      { transform: translate(-12%, 18%) rotate(-90deg); }
      50%      { transform: translate(18%, -8%) rotate(-180deg); }
      75%      { transform: translate(5%, 12%) rotate(-270deg); }
    }
    @keyframes gw-drift-3 {
      0%, 100% { transform: translate(0%, 0%) rotate(0deg); }
      33%      { transform: translate(12%, 12%) rotate(120deg); }
      66%      { transform: translate(-15%, -10%) rotate(240deg); }
    }
    @keyframes gw-drift-4 {
      0%, 100% { transform: translate(0%, 0%) rotate(0deg); }
      20%      { transform: translate(-10%, -15%) rotate(-72deg); }
      40%      { transform: translate(15%, 5%) rotate(-144deg); }
      60%      { transform: translate(-5%, 18%) rotate(-216deg); }
      80%      { transform: translate(12%, -12%) rotate(-288deg); }
    }
    @keyframes gw-drift-5 {
      0%, 100% { transform: translate(0%, 0%) scale(1); }
      30%      { transform: translate(20%, -15%) scale(1.1); }
      60%      { transform: translate(-18%, 20%) scale(0.9); }
      80%      { transform: translate(10%, 10%) scale(1.05); }
    }

    /* Active state — brighter blob colors */
    [data-guava-widget][data-guava-state="active"] .gw-orb-inner { background: #1a8a6a; }
    [data-guava-widget][data-guava-state="active"] .gw-blob-1 { background: radial-gradient(circle, #9adfcf 0%, transparent 60%); }
    [data-guava-widget][data-guava-state="active"] .gw-blob-2 { background: radial-gradient(circle, #5abf80 0%, transparent 55%); }
    [data-guava-widget][data-guava-state="active"] .gw-blob-3 { background: radial-gradient(circle, #3a9fc8 0%, transparent 55%); }
    [data-guava-widget][data-guava-state="active"] .gw-blob-4 { background: radial-gradient(circle, #4dd890 0%, transparent 50%); }

    /* Error state — red blob colors */
    [data-guava-widget][data-guava-state="error"] .gw-orb-inner { background: #8b2020; }
    [data-guava-widget][data-guava-state="error"] .gw-blob-1 { background: radial-gradient(circle, #e88a7a 0%, transparent 60%); }
    [data-guava-widget][data-guava-state="error"] .gw-blob-2 { background: radial-gradient(circle, #c0443a 0%, transparent 55%); }
    [data-guava-widget][data-guava-state="error"] .gw-blob-3 { background: radial-gradient(circle, #a83030 0%, transparent 55%); }
    [data-guava-widget][data-guava-state="error"] .gw-blob-4 { background: radial-gradient(circle, #d45050 0%, transparent 50%); }

    /* Orb — idle breathe */
    [data-guava-widget][data-guava-state="idle"] .gw-orb-inner {
      animation: gw-breathe 4s ease-in-out infinite;
    }
    @keyframes gw-breathe {
      0%, 100% { transform: scale(1); filter: brightness(1); }
      50%      { transform: scale(1.03); filter: brightness(1.08); }
    }

    /* Orb — connecting pulse */
    [data-guava-widget][data-guava-state="connecting"] .gw-orb-inner {
      animation: gw-connecting 1.2s ease-in-out infinite;
    }
    @keyframes gw-connecting {
      0%, 100% { transform: scale(0.97); filter: brightness(0.9); }
      50%      { transform: scale(1.04); filter: brightness(1.1); }
    }

    /* Orb — active: driven by JS audio analyser */
    [data-guava-widget][data-guava-state="active"] .gw-orb-inner {
      transition: transform 0.08s ease-out, filter 0.08s ease-out;
    }

    /* Orb — error breathe */
    [data-guava-widget][data-guava-state="error"] .gw-orb-inner {
      animation: gw-error-breathe 3s ease-in-out infinite;
    }
    @keyframes gw-error-breathe {
      0%, 100% { transform: scale(1); filter: brightness(1); }
      50%      { transform: scale(1.03); filter: brightness(1.08); }
    }

    /* Grain overlay */
    [data-guava-widget] .gw-grain {
      position: absolute;
      inset: 0;
      border-radius: 50%;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='g'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23g)'/%3E%3C/svg%3E");
      background-size: cover;
      mix-blend-mode: overlay;
      opacity: 0.18;
      pointer-events: none;
    }

    /* Specular highlight */
    [data-guava-widget] .gw-specular {
      position: absolute;
      top: 12%;
      left: 18%;
      width: 38%;
      height: 28%;
      border-radius: 50%;
      background: radial-gradient(ellipse, rgba(255,255,255,0.55) 0%, transparent 70%);
      pointer-events: none;
    }

    /* Cursor-following glow */
    [data-guava-widget] .gw-cursor-glow {
      position: absolute;
      inset: 0;
      border-radius: 50%;
      background: radial-gradient(circle at var(--gw-mx, 50%) var(--gw-my, 50%), rgba(150, 255, 210, 0.35) 0%, transparent 60%);
      opacity: 0;
      transition: opacity 0.3s ease;
      pointer-events: none;
    }
    [data-guava-widget]:hover .gw-cursor-glow {
      opacity: 1;
    }

    /* Ripple rings */
    [data-guava-widget] .gw-ripple {
      position: absolute;
      inset: 0;
      border-radius: 50%;
      border: 1.5px solid transparent;
      pointer-events: none;
      opacity: 0;
    }
    [data-guava-widget][data-guava-state="connecting"] .gw-ripple {
      animation: gw-ripple-out 2.4s ease-out infinite;
    }
    [data-guava-widget][data-guava-state="connecting"] .gw-ripple:nth-child(2) { animation-delay: 0.8s; }
    [data-guava-widget][data-guava-state="connecting"] .gw-ripple:nth-child(3) { animation-delay: 1.6s; }
    @keyframes gw-ripple-out {
      0%   { transform: scale(1.0); border-color: rgba(80, 210, 150, 0.5); opacity: 1; }
      100% { transform: scale(1.55); border-color: transparent; opacity: 0; }
    }

    /* ── Caption ── */
    [data-guava-widget] .gw-caption {
      margin-top: 12px;
      font-family: "Barlow", -apple-system, BlinkMacSystemFont, sans-serif;
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      white-space: nowrap;
      color: #6bfbd2;
      text-align: center;
      line-height: 1.3;
    }
    [data-guava-widget][data-guava-state="error"] .gw-caption { color: #E24B4A; }

    [data-guava-widget] .gw-caption-idle,
    [data-guava-widget] .gw-caption-connecting,
    [data-guava-widget] .gw-caption-active,
    [data-guava-widget] .gw-caption-error { display: none; }

    [data-guava-widget][data-guava-state="idle"] .gw-caption-idle         { display: block; }
    [data-guava-widget][data-guava-state="connecting"] .gw-caption-connecting { display: block; }
    [data-guava-widget][data-guava-state="active"] .gw-caption-active     { display: block; }
    [data-guava-widget][data-guava-state="error"] .gw-caption-error       { display: block; }
  `;
  var style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);

  // ── Inject HTML ──
  var wrapper = document.createElement("div");
  wrapper.innerHTML =
    '<div data-guava-widget data-guava-state="idle">' +
      '<div class="gw-orb">' +
        '<div class="gw-orb-inner">' +
          '<div class="gw-blob gw-blob-1"></div>' +
          '<div class="gw-blob gw-blob-2"></div>' +
          '<div class="gw-blob gw-blob-3"></div>' +
          '<div class="gw-blob gw-blob-4"></div>' +
          '<div class="gw-blob gw-blob-5"></div>' +
        '</div>' +
        '<div class="gw-grain"></div>' +
        '<div class="gw-cursor-glow"></div>' +
        '<div class="gw-specular"></div>' +
        '<div class="gw-ripple"></div>' +
        '<div class="gw-ripple"></div>' +
        '<div class="gw-ripple"></div>' +
      '</div>' +
      '<div class="gw-caption">' +
        '<span class="gw-caption-idle">Talk to Guava</span>' +
        '<span class="gw-caption-connecting">Connecting</span>' +
        '<span class="gw-caption-active">Connected</span>' +
        '<span class="gw-caption-error">Call failed</span>' +
      '</div>' +
    '</div>';

  var root = wrapper.firstChild;
  var floatWrapper = document.createElement("div");
  floatWrapper.style.cssText = "position:fixed;bottom:32px;right:32px;z-index:2147483647;";
  floatWrapper.appendChild(root);
  document.body.appendChild(floatWrapper);

  // ── Config ──
  var WEBRTC_CODE = scriptEl.getAttribute("data-webrtc-code");
  var BASE_URL = scriptEl.getAttribute("data-override-api-url") || undefined;

  // ── Audio-reactive orb ──
  var orbInner = root.querySelector(".gw-orb-inner");
  var audioCtx = null;
  var analyser = null;
  var analyserData = null;
  var animFrameId = null;
  var smoothedLevel = 0;

  function startAudioAnalyser(stream) {
    audioCtx = new AudioContext();
    if (audioCtx.state === "suspended") {
      audioCtx.resume();
    }
    var source = audioCtx.createMediaStreamSource(stream);
    analyser = audioCtx.createAnalyser();
    analyser.fftSize = 256;
    analyser.smoothingTimeConstant = 0.4;
    source.connect(analyser);
    analyserData = new Uint8Array(analyser.frequencyBinCount);
    animFrameId = requestAnimationFrame(updateOrb);
  }

  function stopAudioAnalyser() {
    if (animFrameId) {
      cancelAnimationFrame(animFrameId);
      animFrameId = null;
    }
    if (audioCtx) {
      audioCtx.close();
      audioCtx = null;
    }
    analyser = null;
    analyserData = null;
    smoothedLevel = 0;
    orbInner.style.transform = "";
    orbInner.style.filter = "";
  }

  function updateOrb() {
    if (!analyser) return;
    analyser.getByteFrequencyData(analyserData);

    var sum = 0;
    for (var i = 0; i < analyserData.length; i++) {
      sum += analyserData[i];
    }
    var rawLevel = sum / analyserData.length / 255;

    if (rawLevel > smoothedLevel) {
      smoothedLevel += (rawLevel - smoothedLevel) * 0.6;
    } else {
      smoothedLevel += (rawLevel - smoothedLevel) * 0.15;
    }

    var scale = 1.0 + smoothedLevel * 0.4;
    var brightness = 1.0 + smoothedLevel * 0.5;

    orbInner.style.transform = "scale(" + scale + ")";
    orbInner.style.filter = "brightness(" + brightness + ")";

    animFrameId = requestAnimationFrame(updateOrb);
  }

  // ── State management ──
  function setState(state) {
    root.setAttribute("data-guava-state", state);
    if (state !== "active") {
      stopAudioAnalyser();
    }
  }

  var call = null;

  function handleClick() {
    var state = root.getAttribute("data-guava-state");
    if (state === "active") {
      call.hangup();
    } else if (state === "idle" || state === "error") {
      startCall();
    }
  }

  function startCall() {
    setState("connecting");

    call = new Call({ webrtcCode: WEBRTC_CODE, baseUrl: BASE_URL });
    call.onStateChange(function (callState) {
      if (callState === "connected") {
        setState("active");
      } else if (callState === "ended") {
        setState(call.error ? "error" : "idle");
      }
    });
    call.onRemoteStream(function (stream) {
      stopAudioAnalyser();
      startAudioAnalyser(stream);
    });
    // Failures are surfaced through call.error.
    call.start().catch(function () {});
  }

  root.addEventListener("click", handleClick);

  // ── Cursor-following glow ──
  var orbEl = root.querySelector(".gw-orb");
  var cursorGlow = root.querySelector(".gw-cursor-glow");
  orbEl.addEventListener("mousemove", function (e) {
    var rect = orbEl.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    var y = ((e.clientY - rect.top) / rect.height) * 100;
    cursorGlow.style.setProperty("--gw-mx", x + "%");
    cursorGlow.style.setProperty("--gw-my", y + "%");
  });
})();
